<template>
  <div>
    <Card>
      <TablePaginate
        :columns="columns"
        :data="breakages"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_breakages_index_236'),
          key: 'created_at_str',
          align: 'center',
          width: 180
        },
        {
          title: i18n.t('pages_breakages_index_237'),
          key: 'user_name',
          align: 'center',
          width: 180
        },
        {
          title: i18n.t('pages_bookings_detail_222'),
          key: 'fresh_product_name',
          align: 'center'
        },
        {
          title: i18n.t('pages_breakages_index_238'),
          key: 'before_quantity',
          align: 'center',
          width: 120
        },
        {
          title: i18n.t('pages_breakages_index_239'),
          key: 'after_quantity',
          align: 'center',
          width: 120
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'note',
          align: 'center',
          width: 120
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapGetters('breakage', ['breakage', 'breakages', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('breakage', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapMutations('breakage', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    }
  }
}
</script>
